export default [
  {
    path: '/',
    name: 'dashboard',
    component: () => import('@/modules/dashboard/views/Dashboard.vue'),
  },
];
